import React, { useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import "./App.css";
import Header from "./components/Header.tsx";
import SmoothScrollSection from "./components/sections/SmoothScrollSection.tsx";
import PhotosSection from "./components/sections/PhotosSection.tsx";
import LocationSection from "./components/sections/LocationSection.tsx";
import Footer from "./components/Footer.tsx";
import EnvironmentInfoSection from "./components/sections/EnvironmentInfoSection.tsx";
import HouseRulesSection from "./components/sections/HouseRulesSection.tsx";

import AOS from "aos";
import "aos/dist/aos.css";
import EquipmentSection from "./components/sections/EquipmentSection.tsx";
import Checklist from "./components/sections/Checklist.tsx";

const Home = () => (
  <>
    <Header />
    <SmoothScrollSection />
    <PhotosSection />
    <EquipmentSection />
    <EnvironmentInfoSection />
    <HouseRulesSection />
    <LocationSection />
    <Footer />
  </>
);

function App() {
  useEffect(() => {
    AOS.init({
      duration: 1000,
    });
  }, []);

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/checkin" element={<Checklist type="checkin" />} />
        <Route path="/checkout" element={<Checklist type="checkout" />} />
        <Route
          path="*"
          element={<div>Pfad nicht gefunden: {window.location.pathname}</div>}
        />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
